export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stav"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Web"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID obchodu"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení obchodu"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platební odkaz"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivní"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neaktivní"])}
}